import React from 'react';
import { useTranslation } from 'react-i18next';
import { ToggleContainer } from '@weezevent/nacre';
import PropTypes from 'prop-types';
import Style from './activateForAllEvents.module.css';
import { useSegment } from '../../../components/tracking/trackingProvider';

/**
 * Component to activate discount code for all events
 * @param {object} discountForm: discountForm:  object form
 * @param {func} onDiscounts: onDiscounts : func to set discount form
 */

export default function ActivateForAllEvents({ discountForm, onDiscounts }) {
    const { t } = useTranslation();
    const { track } = useSegment();
    return (
        <ToggleContainer
            className={Style['activate-for-all-toggle']}
            subtitle={t('ticket.discountForm.activate_for_all_events.togle_subtitle')}
            title={t('ticket.discountForm.activate_for_all_events.togle_title')}
            toggle={discountForm.account_wide}
            onToggle={value => {
                track('ACTION > DISCOUNT MULTI-EVENT', { 'Page Title': 'CREATE DISCOUNT', Application: 'WeezTicket nBO', Activated: value ? 'True' : 'False' });
                onDiscounts('account_wide', value);
            }}
        />
    );
}

ActivateForAllEvents.propTypes = {
    discountForm: PropTypes.object.isRequired,
    onDiscounts: PropTypes.func.isRequired
};
